<ngx-pull-to-refresh
  spinnerColor="#6c3df4"
  [spinnerSize]="42"
  [distanceForRefresh]="40"
  [isEnable]="true"
  [targetElement]="targetElement"
  (refresh)="myRefreshEvent($event, 'refresh')"
>
  <!-- =====================================================
       AUTHENTICATED APPLICATION
  ====================================================== -->
  <div
    *ngIf="admin.isAdmin()"
    class="ml-admin-layout"
    [class.ml-admin-layout--auth-page]="!showSidebar"
  >
    <!-- ===================================================
         DESKTOP SIDEBAR
    ==================================================== -->
  <aside
  *ngIf="showSidebar"
  class="ml-admin-sidebar"
  [class.is-open]="isOpen"
>
  <div class="ml-admin-sidebar__brand">
    <a routerLink="/" class="ml-admin-sidebar__logo">
      <span class="ml-admin-sidebar__logo-mark">M</span>
      <span class="ml-admin-sidebar__logo-text">Menuload</span>
    </a>

    <button
      type="button"
      class="ml-admin-sidebar__close"
      aria-label="Close navigation"
      (click)="toggleNav($event)"
    >
      <i class="fi fi-rr-cross-small"></i>
    </button>
  </div>

  <nav class="ml-admin-navigation" aria-label="Main navigation">
    <a
      class="ml-admin-navigation__item"
      [routerLink]="['/']"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="menuItemClicked()"
    >
      <span class="ml-admin-navigation__icon">
        <i class="fi fi-rr-apps"></i>
      </span>

      <span>მთავარი</span>
    </a>

    <a
      class="ml-admin-navigation__item"
      [routerLink]="['/app/orders', id]"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="menuItemClicked()"
    >
      <span class="ml-admin-navigation__icon">
        <i class="fi fi-rr-calendar"></i>
      </span>

      <span>{{ 'ORDERS' | translate }}</span>

      <span class="ml-admin-navigation__count">8</span>
    </a>

    <a
      class="ml-admin-navigation__item"
      [routerLink]="['/app/products', id]"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="menuItemClicked()"
    >
      <span class="ml-admin-navigation__icon">
        <i class="fi fi-rr-document"></i>
      </span>

      <span>{{ 'DISHES' | translate }}</span>
    </a>

    <a
      class="ml-admin-navigation__item"
      [routerLink]="['/app/staff', id]"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="menuItemClicked()"
    >
      <span class="ml-admin-navigation__icon">
        <i class="fi fi-rr-user"></i>
      </span>

      <span>პერსონალი</span>
    </a>

    <a
      class="ml-admin-navigation__item"
      [routerLink]="['/app/analitic', id]"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="menuItemClicked()"
    >
      <span class="ml-admin-navigation__icon">
        <i class="fi fi-rr-chart-histogram"></i>
      </span>

      <span>ანალიტიკა</span>
    </a>

    <a
      class="ml-admin-navigation__item"
      [routerLink]="['/app/setting', id]"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="menuItemClicked()"
    >
      <span class="ml-admin-navigation__icon">
        <i class="fi fi-rr-settings"></i>
      </span>

      <span>{{ 'SETTING' | translate }}</span>
    </a>
  </nav>
</aside>

    <!-- Mobile backdrop -->
    <button
      *ngIf="showSidebar && isOpen"
      type="button"
      class="ml-admin-sidebar-backdrop"
      aria-label="Close sidebar"
      (click)="toggleNav($event)"
    ></button>

    <!-- ===================================================
         MAIN APPLICATION AREA
    ==================================================== -->
    <div
      class="ml-admin-main"
      [class.ml-admin-main--shifted]="showSidebar && isOpen"
    >
      <!-- Top header -->
   <header class="ml-admin-header" *ngIf="showSidebar">
  <div class="ml-admin-header__left">
    <button
      *ngIf="showSidebar"
      type="button"
      class="ml-admin-header__menu"
      aria-label="Toggle navigation"
      (click)="toggleNav($event)"
    >
      <i class="fi fi-rr-bars-staggered"></i>
    </button>
  </div>

  <div class="ml-admin-header__actions">
    <button
      *ngIf="showSidebar"
      type="button"
      class="ml-admin-header__action"
      aria-label="Notifications"
    >
      <i class="fi fi-rr-bell"></i>
      <span class="ml-admin-header__notification-dot"></span>
    </button>

    <app-profile class="ml-admin-header__profile"></app-profile>
  </div>
</header>

      <!-- =================================================
           VERIFICATION MODAL
      ================================================== -->
      <ng-template #verifyModal let-modal>
        <div class="ml-verify-modal">
          <div class="modal-header">
            <div>
              <span class="ml-verify-modal__eyebrow">
                ACCOUNT SECURITY
              </span>

              <h5 class="modal-title">
                ელ.ფოსტის ვერიფიკაცია
              </h5>
            </div>

            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              (click)="modal.dismiss('Cross click')"
            ></button>
          </div>

          <div class="modal-body">
            <p class="ml-verify-modal__message">
              თქვენი ელ.ფოსტა
              <strong>{{ email }}</strong>
              არ არის ვერიფიცირებული.
            </p>

            <app-seand [email]="email"></app-seand>
          </div>
        </div>
      </ng-template>

      <!-- Routed pages -->
      <main
        #scrollContainer
        class="ml-admin-content"
        [class.ml-admin-content--auth]="!showSidebar"
         [class.ml-admin-content--pricing]="isPricingPage"
      >
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>

  <!-- =====================================================
       PUBLIC / UNAUTHENTICATED ROUTES
  ====================================================== -->
  <main
    *ngIf="!admin.isAdmin()"
    #scrollContainer
    class="ml-public-content"
  >
    <router-outlet></router-outlet>
  </main>
</ngx-pull-to-refresh>

<!-- Existing mobile bottom navigation -->
<app-navigacion
  *ngIf="admin.isAdmin() && showSidebar"
  [id]="id"
  class="ml-mobile-navigation"
></app-navigacion>